import { get } from "./request"

// 行政区接口
export const getListById = (params: any) =>
    get<any[]>('/api/getListById', params, {})


// 后去目录数据
export const getTreeData = (params?: any) =>
    get<any[]>('/api/getTreeData', params, {})


